import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {finalize, takeUntil, tap} from 'rxjs/operators';
import {CreateServiceOrdreResponseDto} from 'src/app/api/models/OK/EGIS/Service/Ekstern/Models/DTO/create-service-ordre-response-dto';
import {EgisService} from 'src/app/api/services';
import {LoaderService} from 'src/app/services/loader.service';
import * as moment from 'moment';
import {ErrorhandlerService} from 'src/app/services/errorhandler.service';
import {ServiceordreDto} from "src/app/api/models/OK/EGIS/Service/Ekstern/Models/DTO/serviceordre-dto";
import {MatDialog} from "@angular/material/dialog";
import {ConfirmDialogComponent} from "../confirm-dialog/confirm-dialog.component";

@Component({
  selector: 'app-create-serviceordre',
  templateUrl: './create-serviceordre.component.html',
  styleUrls: ['./create-serviceordre.component.scss'],
})
export class CreateServiceordreComponent implements OnInit, OnDestroy {
  form: UntypedFormGroup;
  serviceaftaleNo: number;
  okKundeAftaleNr: number;

  today = new Date();

  unsubscribe$ = new Subject<void>();
  private orders: Array<ServiceordreDto> = [];

  get deadline() {
    return this.form.get('deadline');
  }

  get note() {
    return this.form.get('note');
  }

  constructor(
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private egis: EgisService,
    private loader: LoaderService,
    private snackBar: MatSnackBar,
    private router: Router,
    private errorHandler: ErrorhandlerService,
    private matDialog: MatDialog
  ) {
    this.serviceaftaleNo = Number(
      route.snapshot.paramMap.get('serviceaftaleNo')
    );

    this.okKundeAftaleNr = Number(
      route.snapshot.paramMap.get('okKundeAftaleNr')
    );
    this.form = fb.group({
      deadline: [this.today],
      note: [
        null,
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(500),
        ],
      ],
    });
    if (this.okKundeAftaleNr) {
      this.loader.show();
      this.egis.searchServiceaftaler({
        caller: '', body: {
          searchQuery: this.okKundeAftaleNr.toString()
        }
      })
        .pipe(takeUntil(this.unsubscribe$),
          finalize(() => {
            this.loader.hide();
          })
        ).subscribe(r => {
          const sa = r.serviceaftaler?.shift();
          if (sa && sa.serviceordrer) {
            this.orders = sa.serviceordrer;
          }
        },
        e => this.errorHandler.handleError(e));
    }
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  submit(): void {
    const order = this.getWarning(this.deadline?.value);
    if (order) {
      let confirmdlg = this.matDialog.open<ConfirmDialogComponent>(ConfirmDialogComponent, {data: order});
      confirmdlg.afterClosed().subscribe(p => {
        if (p) this.save();
        else {
          this.snackBar.open('Tilkald oprettelse afbrudt', '', {duration: 3000,});
        }
      });
    } else
      this.save();
  }

  private save() {
    this.loader.show();
    this.egis
      .createServiceordre({
        caller: '',
        body: {
          deadline: this.toOkDateString(this.deadline?.value),
          note: this.note?.value,
          serviceaftaleNo: this.serviceaftaleNo,
        },
      })
      .pipe(
        takeUntil(this.unsubscribe$),
        tap((response: CreateServiceOrdreResponseDto) => {
          console.log(response);
        }),
        finalize(() => {
          this.loader.hide();
        })
      )
      .subscribe(
        (response) => {
          this.snackBar.open('Tilkald oprettet.', 'OK', {
            duration: 3000,
          });
          this.router.navigate(['/']);
        },
        (err) => {
          this.errorHandler.handleError(err);
        }
      );
  }

  toOkDateString(value: any): string {
    return moment(value).format('YYYY-MM-DD');
  }

  private getWarning(p: Date): ServiceordreDto | undefined {
    const from_deadline = moment(this.toOkDateString(p)).add(-1, 'd');
    const to_deadline = moment(this.toOkDateString(p)).add(1, 'd');
    const order_deadline = this.orders
      .filter(
        (o) =>
          moment(o.deadline) >= from_deadline &&
          moment(o.deadline) <= to_deadline &&
          o.serviceordreStateText != 'Annulleret' &&
          o.serviceordreStateText != 'Afvist'
      )
      .shift();
    if (order_deadline) return order_deadline;

    const from_oprettid = moment(this.toOkDateString(this.today)).add(-1, 'd');
    const to_oprettid = moment(this.toOkDateString(this.today)).add(1, 'd');
    return this.orders
      .filter(
        (o) =>
          moment(o.oprettid) >= from_oprettid &&
          moment(o.oprettid) <= to_oprettid &&
          o.serviceordreStateText != 'Annulleret' &&
          o.serviceordreStateText != 'Afvist'
      )
      .shift();
  }
}
